/**
 * Build the v2 attribution metadata to attach to Stripe customer /
 * subscription / setup-intent / checkout-session creation. The webhook
 * reads these fields off the Stripe object and stamps them onto every
 * resulting Statsig event so the LTV funnel is filterable by experiment
 * variant end-to-end.
 *
 * See `packages/statsig/TAXONOMY.md` → Stripe metadata round-trip.
 */
import { readJourneyId } from "../hooks/use-journey-id";

export interface StripeAttributionInput {
  /** Paywall variant the user saw (e.g. "owlet_two_product"). */
  paywallVariant?: string;
  /** Build-time brand constant (e.g. "owlet" | "kinsa"). */
  brand?: string;
  /** Trial length in days as configured on the Stripe price metadata. */
  trialDays?: number;
}

export function getStripeAttributionMetadata(
  input: StripeAttributionInput = {}
): Record<string, string> {
  const result: Record<string, string> = {
    schema_version: "2",
  };
  if (input.brand) result.brand = input.brand;
  if (input.paywallVariant) result.paywall_variant = input.paywallVariant;
  if (typeof input.trialDays === "number") {
    result.trial_days = String(input.trialDays);
  }
  const journeyId = readJourneyId();
  if (journeyId) result.journey_id = journeyId;
  return result;
}
